import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import assign from 'lodash/assign';
import isObject from 'lodash/isObject';
import GlobalStorageService from '../../../services/GlobalStorageService';
import StorageConstants from '../../../constants/StorageConstants';
import { routeMap } from '../../../constants/RouterConstants';

export default {
  _isStackChanged(stack) {
    return stack && stack !== GlobalStorageService.getItem(StorageConstants.STACK);
  },
  pushRoute(routeData, isForced) {
    console.log('Push routeData: ', routeData);
    if (!isObject(routeData)) {  
      throw new Error(
        `RouteHandler~pushRoute: InvalidParamException, expected object found ${typeof routeData}`
      );
    }
    if (isEmpty(routeData)) {
      throw new Error(
        `RouteHandler~pushRoute: InvalidParamException, routeData should not be empty`
      );
    }
    if (
      !isForced &&
      routeData.pathname === GlobalStorageService.getItem(StorageConstants.PREVIOUS_ROUTE, '')
    )
      return false;
    const routeMapping = get(routeMap, routeData.pathname);
    if (isEmpty(routeMapping)) {
      throw new Error(
        `RouteHandler~pushRoute: InvalidParamException, routeMap should not be empty`
      );
    }
    if (this._isStackChanged(routeMapping.stack)) {
      // Resetting stack and Adding current Screen
      GlobalStorageService.setItem(StorageConstants.STACK, routeMapping.stack);
      this.resetStack();
    } else {
      const history = GlobalStorageService.getItem(StorageConstants.ROUTE_HISTORY, []);
      // Adding to CurrentStack
      history.push(assign({}, routeData, routeMapping));
      GlobalStorageService.setItem(StorageConstants.ROUTE_HISTORY, history);
    }
    GlobalStorageService.setItem(StorageConstants.PREVIOUS_ROUTE, routeData.pathname);
    return true;
  },
  popRoute() {
    const history = GlobalStorageService.getItem(StorageConstants.ROUTE_HISTORY, []);
    const lastHistory = history.pop();
    const current = get(history, history.length - 1, {});
    if (!isEmpty(current)) {
      GlobalStorageService.setItem(StorageConstants.PREVIOUS_ROUTE, current.pathname);
    } else {
      GlobalStorageService.setItem(StorageConstants.PREVIOUS_ROUTE, '');
    }
    return lastHistory;
  },
  popIfRouteMismatch(routeData) {
    if (!isObject(routeData)) {
      throw new Error(
        `RouteHandler~popIfRouteMismatch: InvalidParamException, expected object found ${typeof routeData}`
      );
    }
    if (isEmpty(routeData)) {
      throw new Error(
        `RouteHandler~popIfRouteMismatch: InvalidParamException, routeData should not be empty`
      );
    }
    if (routeData.pathname !== GlobalStorageService.getItem(StorageConstants.PREVIOUS_ROUTE, '')) {
      this.popRoute();
    }
  },

  resetStack() {
    let history = GlobalStorageService.getItem(StorageConstants.ROUTE_HISTORY, []);
    history = [];
    GlobalStorageService.setItem(StorageConstants.ROUTE_HISTORY, history);
  },
  isStackEmpty() {
    return isEmpty(GlobalStorageService.getItem(StorageConstants.ROUTE_HISTORY, []));
  },
};
